// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"516":"e0d18447","880":"13c9b4e9","966":"e87652be","977":"b94b78b7"}[chunkId] + ".chunk.js";
};